import { render, staticRenderFns } from "./puContRebateHis.vue?vue&type=template&id=1a8968b8&scoped=true"
import script from "./puContRebateHis.vue?vue&type=script&lang=js"
export * from "./puContRebateHis.vue?vue&type=script&lang=js"
import style0 from "./puContRebateHis.vue?vue&type=style&index=0&id=1a8968b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8968b8",
  null
  
)

export default component.exports